import {PERMISSIONS, useUser} from "../../../core/context/UserContext";
import SimpleLayout from "../../../core/components/layout/SimpleLayout";
import {DataGridProvider} from "../../../core/components/data-grid/DataGridContext";
import {Card, Tabs} from "antd";
import AppointmentFilter from "../calendar/AppointmentFilter";
import AppointmentEntitlementDataGrid from "./AppointmentEntitlementDataGrid";
import moment from "moment";

export default function AppointmentEntitlementConfirmApp({}) {
    const {hasPermission, user} = useUser()

    return (
        <SimpleLayout fullWidth={true}>
            <DataGridProvider
                defaultFilter={{
                    isDeleted: false,
                    entitlementConfirmUserId: user.id,
                    entitlementConfirmStatusList: [1],
                }}
                defaultPagination={{
                    pageNumber: 1,
                    pageSize: 10000
                }}
            >
                <Card>
                    {
                        hasPermission(PERMISSIONS.ENTITLEMENT_CONFIRM) && (<AppointmentEntitlementDataGrid hideConfirmButton={true} />)
                    }
                </Card>
            </DataGridProvider>
        </SimpleLayout>
    )
}